var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.mobile ? 'btn btn-green shadow-sm rounded-md' : 'btn btn-green shadow-sm rounded-md',attrs:{"btntype":_vm.btntype}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }